import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
const getSelectedFilterKeys = (selectedFilters) => Object.entries(selectedFilters)
    .filter(([, { selected }]) => selected)
    .map(([, { category, key }]) => ({ category, key }));
const getCurrentDayWithTime = (time) => {
    const today = dayjs();
    const hm = time.split(":");
    const h = parseInt(hm[0]);
    const m = parseInt(hm[1]);
    const dateWithTime = today.hour(h).minute(m).second(0);
    return dateWithTime;
};
const checkIfStoreIsOpen = (store) => {
    if (!store.opening_hours)
        return false;
    const now = dayjs();
    const currentStoreDay = store.opening_hours[0]?.days[now.isoWeekday() - 1];
    if (!currentStoreDay)
        return false;
    const { open_time, close_time, break_end_time, break_start_time } = currentStoreDay;
    const openTIme = getCurrentDayWithTime(open_time);
    const closeTIme = getCurrentDayWithTime(close_time);
    if (!break_end_time) {
        return now.isBetween(openTIme, closeTIme);
    }
    const breakStartTime = getCurrentDayWithTime(break_start_time);
    const breakEndTime = getCurrentDayWithTime(break_end_time);
    return now.isBetween(openTIme, breakStartTime) || now.isBetween(breakEndTime, closeTIme);
};
const checkStoreBySelectedFilters = (store, selectedFilters) => {
    const selectedFiltersKeys = getSelectedFilterKeys(selectedFilters);
    if (selectedFiltersKeys.length === 0) {
        return true;
    }
    return selectedFiltersKeys.every(({ key, category }) => {
        if (category === "open_now") {
            return checkIfStoreIsOpen(store);
        }
        const storeFilter = store[category];
        return storeFilter?.find((filter) => filter.key === key)?.is_available === "true";
    });
};
export const getStoresFilteredBySelectedFilters = (stores, selectedFilters) => stores.filter((store) => checkStoreBySelectedFilters(store, selectedFilters));
//# sourceMappingURL=getStoresFilteredBySelectedFilters.js.map